import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useCreateClassSession } from "../api/queries";
import { ClassSessionForm } from "../ui/ClassSessionForm";

export function ClassSessionCreatePage() {
  const nav = useNavigate({ from: "/app/classes/sessions/create" });
  const createSession = useCreateClassSession();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຈັດຕາຕະລາງຄລາດສ໌", to: "/app/classes/sessions" },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງ ຊົ່ວໂມງຮຽນ ຄລາດສ໌
            </h2>
            <p className="text-muted-foreground">ສ້າງ ຊົ່ວໂມງຮຽນ ຄລາດສ໌ໃໝ່ໃນລະບົບ.</p>
          </div>

          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/classes/sessions" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <div className="mt-6">
          <ClassSessionForm
            onSubmit={async (vals) => {
              try {
                const result = await createSession.mutateAsync({
                  ...vals,
                  notes: vals.notes ?? null,
                });
                nav({
                  to: "/app/classes/sessions/$id",
                  params: { id: result.id },
                });
              } catch {
                // Error handling is done by the mutation
              }
            }}
            onSubmitAndStay={async (vals) => {
              try {
                await createSession.mutateAsync({
                  ...vals,
                  notes: vals.notes ?? null,
                });
              } catch {
                // Error handling is done by the mutation
              }
            }}
            submitting={createSession.isPending}
          />
        </div>
      </Main>
    </>
  );
}
